import React, {Component} from "react";
import './Loading.css';

export default class Loading extends Component {

    render() {
        return (
            <div className={"loading-container"}>
                <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                <span className="sr-only">Loading...</span>
            </div>
        );
    }
}